module.exports = __webpack_public_path__ + "static/img/circles.344fd88.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/circles.png
// module id = AcaT
// module chunks = 1